const toggleMarketingConsents = (channels, applications, values, name, toggled) => {
	let channelsToggled = 0;
	let productsToggled = 0;
	const tmpValues = values;

	// count how many channels are toggled
	Object.keys(channels).forEach(key => {
		if (tmpValues[`channel-${key}`] === true) {
			channelsToggled++;
		}
	});

	// count how many products are toggled
	for (let i = 0; i < applications.length; i += 1) {
		if (tmpValues[`product-${applications[i].applicationCode}`] === true)  {
			productsToggled++;
		}
	}

	// if user toggles a channel
	if (name.startsWith("channel")) {
		for (let i = 0; i < applications.length; i += 1) {
			// if all channels are untoggled - untoggle all products
			// else if there is a one toggled channel that is the current toggled one, 
			// but all products are untoggled - togggle all products
			if (channelsToggled === 0) {
				tmpValues[`product-${applications[i].applicationCode}`] = false;
			} else if (channelsToggled === 1 && toggled === true && productsToggled < applications.length) {
				tmpValues[`product-${applications[i].applicationCode}`] = true;
				productsToggled++;
			}
		}
	}

	// if user toggles a product
	if (name.startsWith("product")) {
		Object.keys(channels).forEach(key => {
			// if all products are untoggled - untoggle all channels
			// else if there is a one toggled product that is the current toggled one, 
			// but all channels are untoggled - toggle all channels
			if (productsToggled === 0) {
				tmpValues[`channel-${key}`] = false;
			} else if (productsToggled === 1 && toggled === true && channelsToggled < Object.keys(channels).length) {
				tmpValues[`channel-${key}`] = true;
				channelsToggled++;
			}
		});
	}

	return tmpValues;
}

const setCheckbox = (values, id, value) => {
    const tmpValues = values;

    tmpValues[id] = value;

    return tmpValues;
};

// sets all the checkboxes on the page when the component loads
const setAllGlobalConsents = (values, channels, applications, toggled = null) => {
    const tmpValues = values;

    // set the global values of channels
    for (let i = 0; i < applications.length; i += 1) {
        tmpValues[`product-${applications[i].applicationCode}`] = toggled !== null ? toggled : applications[i].isSubscribed;
    }

	  // set the global values of products
	Object.entries(channels).forEach(([key, value]) => {
		tmpValues[`channel-${key}`] = toggled !== null ? toggled : value;
	})

    return tmpValues;
};

export { 
	toggleMarketingConsents,
	setCheckbox,
	setAllGlobalConsents
};
